import { useEffect, useState } from "react";
import MediaController from "../controllers/MediaController.ts";
import IsNullOrEmpty from "../models/helpers/isNullOrEmpty.ts";

const Image = ({
    entityType,
    entityID,
    useFallback = false,
    fallback = '/icons/logo512.png',
    className = ''
}: {
    entityType: 'Aliment' | 'Recipe',
    entityID: number,
    useFallback?: boolean,
    fallback?: string,
    className?: string
}) => {
    const [imageUrl, setImageUrl] = useState<string>(fallback);

    useEffect(() => {
        const fetchImage = async () => {
            try {
                const response = await MediaController.get(entityType, entityID);
                if (!response) {
                    setImageUrl(fallback);
                    return;
                }
                const objectUrl = URL.createObjectURL(response);
                setImageUrl(objectUrl);
            } catch (err) {
                console.error("Failed to load image", err);
                setImageUrl(fallback);
            }
        };

        fetchImage();

        // Cleanup object URL
        return () => {
            if (imageUrl) {
                URL.revokeObjectURL(imageUrl);
            }
        };
    }, [entityType, entityID]);

    if (imageUrl == fallback && useFallback == false) return null;

    return (
        <img src={imageUrl}
            className={`img-fluid rounded ${!IsNullOrEmpty(className) && className}`}
            alt="image not found"
            style={{
                objectFit: "cover",
                maxWidth: "400px",
                width: "100%",
                height: "auto"
            }} />
    );
}

export default Image;